var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalculatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 2.66675H6.66667C5.196 2.66675 4 3.86275 4 5.33341V26.6667C4 28.1374 5.196 29.3334 6.66667 29.3334H25.3333C26.804 29.3334 28 28.1374 28 26.6667V5.33341C28 3.86275 26.804 2.66675 25.3333 2.66675ZM6.66667 26.6667V5.33341H25.3333L25.3347 26.6667H6.66667Z",
    fill: "#90A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 16H12V18.6667H9.33337V16ZM9.33337 21.3333H12V24H9.33337V21.3333ZM14.6667 16H17.3334V18.6667H14.6667V16ZM9.33337 8H22.6667V13.3333H9.33337V8ZM14.6667 21.3333H17.3334V24H14.6667V21.3333ZM20 16H22.6667V24H20V16Z",
    fill: "#90A4AE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculatorIcon.9f1d997baee5dd6453b9896bf9d5c111.svg";
export { ForwardRef as ReactComponent };